<template>
  <div class="loader-back" unselectable="on">
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td width="40%" align="center"></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="input-head-text">Информация</div>
        </td>
      </tr>
      <tr>
        <td colspan="3" align="left">
          <div class="bg-white">
            <OfertText/>
          </div>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" id="btn_back" src="/imgs/back_1.png">
        </td>
        <td width="40%" align="center">
        </td>
        <td width="30%" align="right">
          <img @click="confirmClick" id="btn_back" src="/imgs/confirm_1.png">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import OfertText from "@/components/OfertText.vue";

export default {
  name: "OfertConfirm",
  components: {OfertText},
  props: ['onClose'],
  methods: {
    backClick() {
      this.onClose(false)
    },
    confirmClick() {
      this.onClose(true)
    }
  }
}
</script>

<style scoped>

.loader-back {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  z-index: 9999;
  background-color: #F5F5F5;
  padding: 20px;
}

.bg-white {
  background-color: white;
  padding: 32px;
  border-radius: 16px;
}
</style>
